export const SCSS_PREFIX = 'kic_cs_'
